import { render } from "./OidoCard.vue?vue&type=template&id=c1d04386&scoped=true"
import script from "./OidoCard.vue?vue&type=script&lang=js"
export * from "./OidoCard.vue?vue&type=script&lang=js"

import "./OidoCard.vue?vue&type=style&index=0&id=c1d04386&scoped=true&lang=css"
import "./OidoCard.vue?vue&type=style&index=1&id=c1d04386&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d04386"]])

export default __exports__